import { SAGA_ACTIONS } from '../../../_config'
import { ErrorResponse, SuccessResponse } from '../apiTypes'
import { useApiCall } from '../appApiCallHook'

export function useNotificationApi() {
    const callApi = useApiCall()

    const getnotifications = <P, R>(data: P, onSuccess: (resp: SuccessResponse<R>) => void, onError: (resp: ErrorResponse<R>) => void) => {
        callApi(SAGA_ACTIONS.NOTIFICATION.GET_NOTIFICATIONS, data, onSuccess, onError)
    }

    const notificationmarkallread = <P, R>(data: P, onSuccess: (resp: SuccessResponse<R>) => void, onError: (resp: ErrorResponse<R>) => void) => {
        callApi(SAGA_ACTIONS.NOTIFICATION.MARK_ALL_READ, data, onSuccess, onError)
    }

    const notificationdelete = <P, R>(data: P, onSuccess: (resp: SuccessResponse<R>) => void, onError: (resp: ErrorResponse<R>) => void) => {
        callApi(SAGA_ACTIONS.NOTIFICATION.NOTIFICATION_DELETE, data, onSuccess, onError)
    }

    return {
        getnotifications,
        notificationmarkallread,
        notificationdelete,
    }
}
